import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import FooterSection from '../components/Footer';
import ContactIcon from '../components/ContactIcon';
import './css/organizationalstructure.css';
import lined from '../components/images/hero/lined.png';
import haykalImage from '../components/images/haykal/haykal.jpg';
import { useLanguage } from '../contexts/LanguageContext';

const OrganizationalStructurePage = () => {
  const { language, t } = useLanguage();
  
  const pageTitle = t('pages.organizationalStructure') || (language === 'ar' ? 'الهيكل التنظيمي' : 'Organizational Structure');
  const homeLabel = t('pages.home') || (language === 'ar' ? 'الرئيسية' : 'Home');

  return (
    <>
      <Navbar />
      <section className="page-hero-section">
        <img src={lined} alt="background" className="page-hero-lined" />
        <div className="page-hero-overlay"></div>
        <div className="container">
          <motion.div 
            className="page-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>{pageTitle}</h1>
            <nav className="page-hero-breadcrumb">
              <Link to="/">{homeLabel}</Link>
              <span>/</span>
              <span>{pageTitle}</span>
            </nav>
          </motion.div>
        </div>
      </section>
      
      <section className="organizational-structure-section">
        <div className="container">
          <motion.div
            className="organizational-structure-content"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="structure-image-wrapper">
              <img 
                src={haykalImage} 
                alt={pageTitle}
                className="structure-image"
              />
            </div>
          </motion.div>
        </div>
      </section>
      
      <FooterSection />
      <ContactIcon />
    </>
  );
};

export default OrganizationalStructurePage;

